import { useEffect, useState } from "react";
import {
  DEFAULT_TRANSPARENCY,
  applyTransparencyToDocument,
  fetchTransparencyConfig,
  getPreviewTransparency,
  type TransparencyConfig,
} from "@/lib/transparencyConfig";

/**
 * Loads marketing transparency settings (or local admin preview) and applies
 * them as CSS variables on <html>. Returns the active config.
 */
export const useTransparencyConfig = (): TransparencyConfig => {
  const [config, setConfig] = useState<TransparencyConfig>(
    () => getPreviewTransparency() ?? DEFAULT_TRANSPARENCY,
  );

  useEffect(() => {
    applyTransparencyToDocument(config);
  }, [config]);

  useEffect(() => {
    let cancelled = false;
    const preview = getPreviewTransparency();
    if (preview) {
      setConfig(preview);
    } else {
      void fetchTransparencyConfig().then((cfg) => {
        if (!cancelled) setConfig(cfg);
      });
    }
    const onPreviewChange = () => {
      const p = getPreviewTransparency();
      if (p) setConfig(p);
      else void fetchTransparencyConfig().then((cfg) => { if (!cancelled) setConfig(cfg); });
    };
    window.addEventListener("mkt-transparency-preview-change", onPreviewChange);
    window.addEventListener("storage", onPreviewChange);
    return () => {
      cancelled = true;
      window.removeEventListener("mkt-transparency-preview-change", onPreviewChange);
      window.removeEventListener("storage", onPreviewChange);
    };
  }, []);

  return config;
};
